<template>
  <tr class="border-b">
    <td
      class="py-4 align-center text-left font-medium pr-6"
      :class="{
         'pl-6': Boolean(parent)
      }">
      <div v-if="isEditing" class="flex justify-content-center">
        <select class="flex-initial select-type" v-model="editType" @change="changeFeature">
          <option value="PAGE">Page</option>
          <option value="URI">Link</option>
          <option value="FEATURE">Feature</option>
        </select>
        <input v-if="this.isPage" type="text" class="input-sm flex-1 ml-4 inline-block edit-name" v-model="editName"/>
        <br />

        <label class="ml-2 pt-2">Slug</label>
        <input v-if="this.isPage" type="text" class="input-sm flex-1 ml-4 inline-block edit-name" v-model="editSlug"/>
        <template v-else>
          <select v-if="this.isFeature" class="flex-1 ml-4 mr-6 select-feature" v-model="editSlug">
            <option :value="undefined">Choose Feature...</option>
            <option v-for="feature in getFeatureList()" :key="feature.slug" :value="feature.slug">{{ feature.name }}
            </option>
          </select>
          <input v-else class="input-sm flex-1 inline-block ml-4 edit-slug" v-model="editSlug"/>
          <input type="text" class="input-sm flex-1 inline-block ml-4 edit-name" v-model="editName"/>
        </template>
      </div>
      <template v-else>
        <span v-if="!this.isPage" class="text-grey-dark feature-type">{{ humanReadableFeatureType }}: </span>
        <span class="menu-name">{{ this.editName }}</span>
      </template>
      <!-- Menu Network & Country -->
      <div v-if="isEditing && system.networks.length > 1 && (system.networks[0].id === 7 || system.networks[0].id === 8)" class="mt-4 border-t-2">
      <p class="w-full mb-2 mt-2">Menu visibility by Network:</p>
      <div v-for="(network, i) in system.networks" :key="i" class="text-sm uppercase">
        <input type="radio" :id="`menu-`+radioBtnId+`-`+i" :value="network.id" v-model="editAssignedNetwork">
        <label :for="`menu-`+radioBtnId+`-`+i" class="ml-4 mt-2 text-xs">{{ network.name }}</label>
      </div>
      <input type="radio" :id="`menu-`+radioBtnId+`-all`" :value="null" v-model="editAssignedNetwork" class="text-xs">
      <label :for="`menu-`+radioBtnId+`-all`" class="ml-4 mt-2 text-xs">ALL</label>
      <!-- Country -->
      <p class="w-full mb-2 mt-2">Menu visible to (Country):</p>
      <select-input class="mt-4 text-xs"
        v-model="editAssignedCountries"
        :options="editCountryList"
      />
      <!-- Country End -->
      </div>
      <!-- Menu Network & Country End -->
    </td>
    <td class="py-4 align-center text-center font-medium w-1/4">
      <div class="flex items-center justify-end text-base">
        <div v-if="system.external_data.plan === true && isEditing" class="mr-2">
          <input :id="'guildlite' + id" class="mr-2 leading-tight" type="checkbox" v-model="editGuildLite">
          <label :for="'guildlite' + id">
            <span class="text-sm">
              Guild Lite
            </span>
          </label>
        </div>
        <button v-if="id && !parent" @click="addChildMenu" type="button" class="shadow-none p-1 mr-4 action-create-child" title="Add child menu">
          <i class="fa-lg fas fa-plus fa-fw"/>
        </button>

        <button v-if="isEditing" @click="save" type="button" class="shadow-none p-1 mr-4 action-save" title="Save menu">
          <i class="fa-lg far fa-save fa-fw"/>
        </button>
        <button v-else @click="enableEditing" type="button" class="shadow-none p-1 mr-4 action-edit" title="Edit menu">
          <i class="fa-lg far fa-edit fa-fw"/>
        </button>

        <button type="button" @click="destroy" class="shadow-none action-delete" title="Delete menu">
          <i class="fa-lg far fa-trash-alt fa-fw"/>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex'
import randomstring from 'randomstring'
export default {
  name: 'MenuEdit',
  computed: {
    humanReadableFeatureType () {
      const map = {
        feature: 'Feature',
        uri: 'Link',
        page: 'Page'
      }

      return map[this.editType.toLowerCase()]
    },

    isFeature () {
      return this.editType === 'FEATURE'
    },

    isPage () {
      return this.editType === 'PAGE'
    },

    isUri () {
      return this.editType === 'URI'
    },
    ...mapState([
      'system'
    ])
  },

  data () {
    let defaultCountryList = [
      { 'id': 'GB', 'name': 'UK' },
      { 'id': 'UKA', 'name': 'UK Associate' },
      { 'id': 'AU', 'name': 'Australia' },
      { 'id': 'BB', 'name': 'Barbados' },
      { 'id': 'BG', 'name': 'Bulgaria' },
      { 'id': 'CY', 'name': 'Cyprus' },
      { 'id': 'EE', 'name': 'Estonia' },
      { 'id': 'FI', 'name': 'Finland' },
      { 'id': 'FR', 'name': 'France' },
      { 'id': 'DE', 'name': 'Germany' },
      { 'id': 'GR', 'name': 'Greece' },
      { 'id': 'HU', 'name': 'Hungary' },
      { 'id': 'IE', 'name': 'Ireland' },
      { 'id': 'IT', 'name': 'Italy' },
      { 'id': 'JE', 'name': 'Jersey' },
      { 'id': 'MU', 'name': 'Mauritius' },
      { 'id': 'NA', 'name': 'Namibia' },
      { 'id': 'PT', 'name': 'Portugal' },
      { 'id': 'ES', 'name': 'Spain' },
      { 'id': 'ZA', 'name': 'South Africa' },
      { 'id': 'CH', 'name': 'Switzerland' },
      { 'id': 'TH', 'name': 'Thailand' },
      { 'id': 'AE', 'name': 'UAE' },
      { 'id': 'ZW', 'name': 'Zimbabwe' }
    ]
    let defaultAssignedCountries = ['GB', 'UKA', 'AU', 'BB', 'FR', 'DE', 'HU', 'IE', 'JE', 'MU', 'NA', 'PT', 'ZA', 'ES', 'CH', 'TH', 'AE', 'ZW', 'CY']
    if (this.id) {
      defaultAssignedCountries = defaultCountryList
    }
    return {
      isEditing: (!this.name || !this.slug || !this.type),
      editName: this.name,
      editSlug: this.slug,
      editType: this.type || 'PAGE',
      editGuildLite: this.guild_lite,
      editAssignedCountries: this.assigned_countries || defaultAssignedCountries,
      editCountryList: defaultCountryList,
      editAssignedNetwork: this.assigned_network || null,
      radioBtnId: randomstring.generate()
    }
  },

  methods: {
    addChildMenu () {
      this.$emit('createChild')
    },

    changeFeature (e) {
      this.editType = e.target.value

      if (this.editType === this.type) {
        this.editSlug = this.slug
      } else {
        if (this.isUri) {
          this.editSlug = 'https://'
        } else if (this.isFeature) {
          this.editSlug = undefined
        } else {
          this.editSlug = undefined
        }
      }
    },

    getFeatureList () {
      const features = {
        digitalHub: 'Digital Hub',
        insight: 'Insight',
        knowledgeHub: 'Knowledge Hub',
        marketingPack: 'Marketing Pack',
        partnerPages: 'Partner Pages',
        pom: 'Print Order Manager',
        propertyCms: 'Property CMS',
        propertyFeeds: 'Property Feeds',
        referrals: 'Referrals',
        webinars: 'Webinars',
        websiteCms: 'Website CMS',
        annualReview: 'Annual Review',
        qrGenerator: 'Custom QR Code Maker'
      }

      const response = []

      for (let key in features) {
        response.push({
          name: features[key],
          slug: key
        })
      }

      return response
    },

    getMenuData () {
      return {
        id: this.id,
        name: this.editName,
        slug: this.editSlug,
        parent: this.parent,
        type: this.editType,
        guild_lite: this.editGuildLite,
        assigned_countries: this.editAssignedCountries,
        country_list: this.editCountryList,
        assigned_network: this.editAssignedNetwork
      }
    },

    destroy () {
      this.$emit('destroy')
    },

    enableEditing () {
      this.isEditing = true
    },

    save () {
      this.$emit('save', this.getMenuData())
      this.isEditing = false
    },
    toggleSelectAllCountries (flag) {
      this.editAssignedCountries = []
      if (flag) {
        for (var index in this.editCountryList) {
          this.editAssignedCountries.push(this.editCountryList[index].id)
        }
      }
    }
  },
  props: {
    id: {
      type: Number
    },
    name: {
      type: String
    },
    parent: {
      type: Number
    },
    slug: {
      type: String
    },
    type: {
      type: String
    },
    guild_lite: {
      type: Boolean
    },
    country_list: {
      type: Array
    },
    assigned_countries: {},
    assigned_network: {
      type: Number
    }
  },
  watch: {
    'editAssignedNetwork': {
      handler () {
        this.editCountryList = [
          { 'id': 'GB', 'name': 'UK' },
          { 'id': 'UKA', 'name': 'UK Associate' },
          { 'id': 'AU', 'name': 'Australia' },
          { 'id': 'BB', 'name': 'Barbados' },
          { 'id': 'BG', 'name': 'Bulgaria' },
          { 'id': 'CY', 'name': 'Cyprus' },
          { 'id': 'EE', 'name': 'Estonia' },
          { 'id': 'FI', 'name': 'Finland' },
          { 'id': 'FR', 'name': 'France' },
          { 'id': 'DE', 'name': 'Germany' },
          { 'id': 'GR', 'name': 'Greece' },
          { 'id': 'HU', 'name': 'Hungary' },
          { 'id': 'IE', 'name': 'Ireland' },
          { 'id': 'IT', 'name': 'Italy' },
          { 'id': 'JE', 'name': 'Jersey' },
          { 'id': 'MU', 'name': 'Mauritius' },
          { 'id': 'NA', 'name': 'Namibia' },
          { 'id': 'PT', 'name': 'Portugal' },
          { 'id': 'ES', 'name': 'Spain' },
          { 'id': 'ZA', 'name': 'South Africa' },
          { 'id': 'CH', 'name': 'Switzerland' },
          { 'id': 'TH', 'name': 'Thailand' },
          { 'id': 'AE', 'name': 'UAE' },
          { 'id': 'ZW', 'name': 'Zimbabwe' }
        ]
        if (this.editAssignedNetwork === 7) {
          this.editCountryList = this.editCountryList.splice(0, 2)
        } else if (this.editAssignedNetwork === 8) {
          this.editCountryList = this.editCountryList.splice(2, this.editCountryList.length)
        }
        this.toggleSelectAllCountries(true)
      }
    }
  }
}
</script>
